<template src="./template.html" ></template>

<script>
// @ is an alias to /src
import {
  toJalaali,
  isValidJalaaliDate
} from '../../functions/myDate';
import myAxios from '../../functions/myAxios'
import MyListTable from './table.vue'
import MyButtons from './Buttons.vue'
import MyDate from '../../components/MyDate.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
// import setting from './setting.json'

// const XLSX = require("xlsx")
//
export default {
  name: 'BankControl',
  methods: {
    getRequestParams(searchItem, searchText) {
      let params = {};

      if (searchItem) {
        params["searchItem"] = searchItem;
      }

      if (searchText) {
        params["searchText"] = searchText;
      }

      return params;
    },
    async retrieveBankaccounts() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/bank_accounts/name`,
        });
        if (res && res.data) {
          // console.log(res);
          this.bank_accounts = res.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async debounceSearch() {
      clearTimeout(this.debounce)
      if (isValidJalaaliDate(this.search_date_from) && isValidJalaaliDate(this.search_date_to)) {
        this.debounce = setTimeout(async () => {
          await this.retrieveDataBill()
          await this.retrieveDataHb()
          //
          // console.clear();
          let bill_prices = []
          for (let i in this.bill_data) {
            bill_prices.push(
              Number(this.bill_data[i].price)
            )
          }
          let hb_prices = []
          for (let i in this.hb_data) {
            hb_prices.push(
              Number(this.hb_data[i].price)
            )
          }
          this.hb_diff = this.diff(hb_prices, bill_prices)
          this.bill_diff = this.diff(bill_prices, hb_prices)
          //
        }, 800)
      }
    },
    async retrieveDataHb() {
      this.hb_data = []
      if (!this.bank_account_id || !this.search_date_from || !this.search_date_to) {
        // alert('حساب بانکی را انتخاب کنید')
        return
      }
      this.loading = true
      let query = this.getRequestParams(
        this.searchItem.name,
        this.searchText,
      )
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}/hb`,
          // params: query
          params: {
            mid: this.bank_account_id,
            form: this.search_date_from,
            to: this.search_date_to,
            searchItem: query.searchItem,
            searchText: query.searchText
            // search : query
          }
        });
        if (res && res.data && res.data.length) {
          this.hb_data = res.data
          this.hb_data.sort((a, b) => a.price - b.price);
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async retrieveDataBill() {
      this.bill_data = []
      if (!this.bank_account_id || !this.search_date_from || !this.search_date_to) {
        // alert('حساب بانکی را انتخاب کنید')
        return
      }
      this.loading = true
      let query = this.getRequestParams(
        this.searchItem.name,
        this.searchText,
      )
      try {
        // console.log(query);
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}`,
          params: {
            mid: this.bank_account_id,
            from: this.search_date_from,
            to: this.search_date_to,
            searchItem: query.searchItem,
            searchText: query.searchText
          }
        });
        if (res && res.data && res.data.length) {
          this.bill_data = res.data
          this.bill_data.sort((a, b) => a.price - b.price);
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async setDateFrom(item) {
      this.search_date_from = item
      this.search_date_to = item
      this.debounceSearch()
    },
    async setDateTo(item) {
      this.search_date_to = item
      this.debounceSearch()
    },
    set3zeroPrice(item) {
      this.searchText = item
      this.debounceSearch()
    },
    handleChangeSelectItem() {
      this.searchText = null
    },
    // myFileReader(file, cb) {
    //   let fileReader = new FileReader()
    //   fileReader.readAsBinaryString(file)
    //   fileReader.onload = (e) => {
    //     // console.log(e.target.result);
    //     let data = e.target.result
    //     let workbook = XLSX.read(data, {
    //       type: 'binary'
    //     })
    //     workbook.SheetNames.forEach(sheet => {
    //       let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
    //       // console.log(rowObject);
    //       return cb({
    //         result: rowObject
    //       })
    //     })
    //   }
    // },
    // mellat(fr) {
    //   this.columns = setting['1']
    //   fr.reverse()
    //   for (let i in fr) {
    //     let row = fr[i]
    //     let obj = {
    //       bank_account_id: this.bank_account_id
    //     }
    //     // console.log(row);
    //     if (row['مبلغ گردش بستانکار'] === 0) {
    //       row['مبلغ گردش بستانکار'] = row['مبلغ گردش بدهکار']
    //     }
    //     obj['date'] = row['تاریخ']
    //     obj['time'] = row['زمان']
    //     obj['serial'] = String(row['شماره سریال'])
    //     obj['depositor'] = String(row['واریز کننده/ ذیتفع']).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    //     obj['description'] = String(row['شرح']).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    //     obj['price'] = Number(row['مبلغ گردش بستانکار'])
    //     //
    //     this.rows.push(obj)
    //   }
    //   //end
    // },
    // saderat(fr) {
    //   this.columns = setting['3']
    //   for (let i in fr) {
    //     let row = fr[i]
    //     let obj = {
    //       bank_account_id: this.bank_account_id
    //     }
    //     // console.log(row);
    //     const Variz = 'واريز'
    //     const bardasht = 'برداشت'
    //     if (row[Variz] === 0) row[Variz] = row[bardasht]
    //     if (row['شماره پیگیری'] === undefined) row['شماره پیگیری'] = ''
    //     if (row['نام'] === undefined) row['نام'] = ''
    //
    //     const Tariz = 'تاریخ'
    //     let _date = row[Tariz]
    //     row[Tariz] = String(_date).substring(0, 4) + '/' + String(_date).substring(4, 6) + '/' + String(_date).substring(6, 8)
    //     // console.log(row[Tariz]);
    //     obj['date'] = String(row[Tariz])
    //     obj['time'] = String(row['ساعت'])
    //     obj['serial'] = String(row['فيش/حواله'])
    //     obj['price'] = Number(row[Variz])
    //     obj['depositor'] = String(row['اطلاعات اضافی'])
    //     obj['description'] = String(row['شماره پیگیری'])
    //     obj['name'] = String(row['نام'])
    //     //
    //     this.rows.push(obj)
    //   }
    //   //end
    // },
    // melli(fr) {
    //   this.columns = setting['2']
    //   let titleNames = [
    //     "", "date", "time", "", "type", "price", "", "depositor", "description", "serial", "", "", "", ""
    //   ]
    //   fr.map((row, i) => {
    //     if (i > 3) {
    //       let rows = Object.values(row)
    //       // dates.push(rows[1])
    //       let obj = {
    //         bank_account_id: this.bank_account_id
    //       }
    //       let propName = null
    //       rows.forEach((item, j) => {
    //         if ([1, 2, 4, 5, 7, 8, 9].includes(j)) {
    //           propName = titleNames[j]
    //           obj[propName] = item
    //         }
    //       })
    //       this.rows.push(obj)
    //     }
    //   })
    //   //end
    // },
    // show() {
    //   if (this.files.length === 0) {
    //     alert('فایل اکسل را انتخاب کنید.')
    //     return;
    //   }
    //   this.columns = []
    //   this.rows = []
    //   let bank_account = this.bank_accounts.filter(b => this.files[0].name.includes(b.number))
    //   if (bank_account.length) {
    //     let file = this.files[0]
    //     let bankName = bank_account[0].bank[0]
    //     //
    //     this.myFileReader(file, (fr) => {
    //       if (fr && fr.result && bankName === 'ملت') {
    //         this.mellat(fr.result)
    //       } else if (fr && fr.result && bankName === 'ملی') { //saderat
    //         this.melli(fr.result)
    //       } else if (fr && fr.result && bankName === 'صادرات') { //melli
    //         this.saderat(fr.result)
    //       }
    //     })
    //   } else {
    //     alert('no match')
    //   }
    // },
    diff(a, b) {
      a = [].concat(a)
      b = [].concat(b)
      //
      let diff = []
      for (let i in a) {
        if (b.indexOf(a[i]) != -1) {
          b.splice(b.indexOf(a[i]), 1)
        } else {
          diff.push(a[i])
        }
      }
      return diff
    },
    clearTable() {
      this.rows = []
    },
    back() {
      this.$router.push(`/`)
    },
  },
  computed: {
    myBillDiff() {
      return this.bill_diff.map(item => ({
        'price': item
      }));
    },
    myHbDiff() {
      return this.hb_diff.map(item => ({
        'price': item
      }));
    }
  },
  async created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.headers = this.$store.getters.pageInfo.headers
    this.hb_headers = this.$store.getters.pageInfo.hb_headers
    this.bill_headers = this.$store.getters.pageInfo.bill_headers
    this.searchItems = this.$store.getters.pageInfo.searchItems
    if (this.searchItems && this.searchItems.length) {
      this.searchItem = this.searchItems[0]
    }
    //
    this.retrieveBankaccounts()
  },
  data: () => ({
    loading: false,
    //search
    search_date_from: toJalaali(new Date()).date,
    search_date_to: toJalaali(new Date()).date,
    searchItem: [],
    searchText: "",
    //
    bank_accounts: [],
    bank_account_id: null,
    files: [],
    hb_headers: [],
    hb_data: [],
    hb_diff: [],
    bill_headers: [],
    bill_data: [],
    bill_diff: [],
    //
    progressValue: 0,
  }),
  components: {
    MyListTable,
    MyButtons,
    MyDate,
    MyCurrency,
    MyBankaccounts,
  },
}
</script>
